import { PiMagnifyingGlassThin, PiX } from 'react-icons/pi';
import React, { useId } from 'react';
import {
  Flex,
  Input,
  FormControl,
  InputGroup,
  InputRightElement,
  Button,
  Text,
  Icon,
  Link,
  Show,
  FormLabel,
  useTheme,
} from '@chakra-ui/react';

export default function InputFile({
  label,
  id = null,
  acceptedFormats,
  inputSize,
  isInvalid,
  isDisabled,
  isRequired,
  onChange,
  fileUrl = null,
  fileName = null,
  onFileDelete,
}) {
  const theme = useTheme();

  let inputId = `file-${useId()}`;
  if (id !== undefined) {
    inputId = id;
  }

  return (
    <Flex
      direction="column"
      gap="0.25rem"
      cursor="pointer"
      maxWidth={theme.maxFieldsWidth}
    >
      <Flex
        align="center"
        justify="center"
        width="100%"
        pointerEvents={isDisabled && 'none'}
      >
        <FormControl isRequired={isRequired} isInvalid={isInvalid}>
          <InputGroup>
            <Input
              id={inputId}
              type="file"
              size={inputSize ? inputSize : null}
              accept={acceptedFormats ? acceptedFormats : null}
              lineHeight={inputSize === 'sm' ? '1.75rem' : '2.25rem'}
              cursor={!isDisabled && 'pointer'}
              onChange={onChange}
              required={isRequired}
              sx={{
                '::file-selector-button': {
                  display: 'none',
                },
              }}
            />
            <InputRightElement
              width="fit-content"
              pointerEvents="none"
              height="100%"
            >
              <Button
                size="xs"
                sx={{
                  px: '0.75rem',
                  minHeight: '100%',
                  borderTopLeftRadius: '0',
                  borderBottomLeftRadius: '0',
                }}
              >
                <Text display={['none', '', 'block']}>
                  {label ? label : 'Ajouter un fichier'}
                </Text>
                <Icon
                  as={PiMagnifyingGlassThin}
                  boxSize="1rem"
                  display={['block', '', 'none']}
                />
              </Button>
            </InputRightElement>
          </InputGroup>
          {fileUrl && (
            <Flex
              justify="center"
              align={['end', 'center']}
              gap={['0.75rem', '1.5rem']}
              fontSize="0.75rem"
            >
              <Flex align="end" gap="0.25rem">
                <Link as={'a'} target={'_blank'} href={fileUrl}>
                  <Text>
                    Fichier sélectionné :{' '}
                    <Text as="span" fontWeight="600">
                      {fileName.length > 20
                        ? fileName.slice(0, 20) + '...'
                        : fileName}
                    </Text>
                  </Text>
                </Link>
              </Flex>

              <Show breakpoint="(min-width: 768px)">
                <Text
                  textDecoration="underline"
                  cursor="pointer"
                  onClick={() => {
                    onFileDelete();
                  }}
                >
                  Supprimer le fichier
                </Text>
              </Show>
              <Show breakpoint="(max-width: 768px)">
                <Icon
                  as={PiX}
                  boxSize="1rem"
                  cursor="pointer"
                  color="danger.100"
                  onClick={() => onFileDelete()}
                />
              </Show>
            </Flex>
          )}
        </FormControl>
      </Flex>
    </Flex>
  );
}
